import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';
import { YoutubeShortsLogoComponent } from '../../../preview-common/youtube/youtube-shorts-logo/youtube-shorts-logo.component';
import { YoutubeMobileBottomNavComponent } from '../../../preview-common/youtube/youtube-mobile-bottom-nav/youtube-mobile-bottom-nav.component';
import { YoutubeMobileNavbarComponent } from '../../../preview-common/youtube/youtube-mobile-navbar/youtube-mobile-navbar.component';

/**
 * Performance Max on the YouTube home feed (mobile): portrait image in a
 * square player, with long headline, description and two CTA buttons below.
 */
@Component({
    selector: 'app-pmax-youtube-mobile-04',
    imports: [
        CommonModule,
        MobileFrameComponent,
        YoutubeMobileNavbarComponent,
        YoutubeMobileBottomNavComponent,
        YoutubeShortsLogoComponent,
    ],
    templateUrl: './youtube-mobile-04.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-mobile-04.component.scss',
    ]
})
export class PmaxYoutubeMobile04PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** This placement's creative slot is the 4:5 portrait format. */
  readonly creativeFormat: CreativeFormat = 'portrait';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
